import {Modal} from "bootstrap";

export default function () {
    $(function () {
        confirm();
    });
}

export function confirm() {
    const modalElement = document.getElementById('confirm-modal');
    if (!modalElement) {
        return;
    }
    const $modal = $('#confirm-modal');
    const modal = Modal.getOrCreateInstance(modalElement);
    const $modalTitle = $('.modal-title', $modal);
    const $modalConfirmButton = $('.confirm-btn', $modal);

    // confirm link
    $('a[confirm-text]').on('click', function (e) {
        e.preventDefault();
        modal.show();
        $modalTitle.html($(this).attr('confirm-text'));
        // set original link as submit-link
        $modalConfirmButton.attr('href', $(this).attr('href'));
    });

    // confirm form
    let isFormConfirmed = false;
    $('button[confirm-text]', 'form').on('click', function (e) {
        if (!isFormConfirmed) {
            e.preventDefault();
            modal.show();
            const $confirmButton = $(this);
            $modalTitle.html($confirmButton.attr('confirm-text'));
            $modalConfirmButton.on('click', function (e) {
                e.preventDefault();
                isFormConfirmed = true;
                // submit the form by triggering the click
                // (so that the button is submitted too)
                $confirmButton.trigger('click');
            });
        }
    });

    $modal.on('hidden.bs.modal', function () {
        // Reset modal href and click when closing to prevent interference with different confirm modals
        $modalConfirmButton.off('click');
        $modalConfirmButton.attr('href', '');
    });
}